import request from '@/router/axios'
import env from '@/config/env'

export const queryCopyWritingPage = (data) => {
  return request({
    url: env.ferryUrl + '/boss-operation/custom-content/page',
    method: 'POST',
    data
  })
}

export const addCopyWriting = (data) => {
  return request({
    url: env.ferryUrl + '/boss-operation/custom-content',
    method: 'POST',
    data
  })
}
